export default {
  data() {
    return {};
  },
  computed: {
    footerText() {
      return this.$store.state.settings.footer_text;
    },
  },
  methods: {
    showPrivacyPolicy() {
      window.open('/media/uploads/confidence.pdf', '_blank');
    },
  },
};
